import { message } from "antd";
import authService from "../services/auth/index1";
import publicService from "../services/public";
import { localErrorHandler } from "../utils/errorHandler";
const namespace = "auth";
const initialState = {
  user: null,
  loading: {
    signup: false,
    login: false,
    logout: false,
    getShops: false,
    loginAs: false,
    resetPassword: false,
    forgotPassword: false,
    resetSuperAdminPassword: false,
  },
  shops: [],
};

export const loginWithEmail = (email, password, shopId) => ({
  type: `${namespace}/loginWithEmail`,
  payload: {
    data: { email, password },
    shopId,
  },
});

export const logout = () => ({
  type: `${namespace}/logout`,
});

export const verifyEmail = (data, shopId) => ({
  type: `${namespace}/verifyEmail`,
  data,
  shopId,
});

export const forgotPassword = ({ email, shopId }) => ({
  type: `${namespace}/forgotPassword`,
  payload: {
    email,
    shopId,
  },
});

export const getUser = (userId) => ({
  type: `${namespace}/getUser`,
  userId,
});

export const getShopsByEmail = (email) => ({
  type: `${namespace}/getShopsByEmail`,
  email,
});

export const loginAs = (shopId) => ({
  type: `${namespace}/loginAs`,
  payload: {
    shopId,
  },
});

export const resetPassword = (payload) => ({
  type: `${namespace}/resetPassword`,
  payload,
});
export const resetSuperAdminPassword = (payload) => ({
  type: `${namespace}/resetSuperAdminPassword`,
  payload,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *resetSuperAdminPassword({ payload }, { call, put }) {
      yield put({
        type: "startLoading",
        loadingType: "resetSuperAdminPassword",
      });
      try {
        const response = yield call(
          authService.resetSuperAdminPassword,
          payload.data,
        );
        if (response) {
          message.success(response.data.message);
        }
        yield put({
          type: "stopLoading",
          loadingType: "resetSuperAdminPassword",
        });
        return response;
      } catch (error) {
        localErrorHandler({
          namespace,
          error,
          stopLoading: "resetSuperAdminPassword",
        });
      }
    },
    *forgotPassword({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "forgotPassword" });
      try {
        const response = yield call(
          authService.forgotPassword,
          payload.email,
          payload.shopId,
        );
        if (response) {
          message.success(response.data.message);
        }
        yield put({ type: "stopLoading", loadingType: "forgotPassword" });
        return response;
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "forgotPassword" });
      }
    },
    *resetPassword({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "resetPassword" });
      try {
        const response = yield call(
          authService.resetPassword,
          payload.data,
          payload.shopId,
        );
        if (response) {
          message.success(response.data.message);
        }
        yield put({ type: "stopLoading", loadingType: "resetPassword" });
        return response;
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "resetPassword" });
      }
    },
    *loginAs({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "loginAs" });

      try {
        const response = yield call(
          authService.shopLoginAs,

          payload.shopId,
        );

        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        localStorage.setItem("userId", response.data.user.id);
        localStorage.setItem("shopId", response.data.user.shop_id);

        yield put({ type: "setUser", user: response.data.user });
        yield put({ type: "stopLoading", loadingType: "loginAs" });
        window.location.reload();
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "loginAs" });
      }
    },
    *getShopsByEmail({ email }, { call, put }) {
      // Clear shops before fetching new ones
      yield put({ type: "setShops", shops: [] });
      yield put({ type: "startLoading", loadingType: "getShops" });
      try {
        const response = yield call(publicService.getShopsByEmail, email);

        yield put({ type: "setShops", shops: response });
        yield put({ type: "stopLoading", loadingType: "getShops" });
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "getShops" });
      }
    },
    *getUser({ userId }, { call, put }) {
      try {
        const response = yield call(publicService.shopUserById, userId);
        yield put({ type: "setUser", user: response.data });
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "getUser" });
      }
    },
    *logout(_, { call, put }) {
      yield put({ type: "startLoading", loadingType: "logout" });
      try {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("shopId");
        yield put({ type: "setUser", user: null });
        yield put({ type: "stopLoading", loadingType: "logout" });
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "logout" });
      }
    },
    *loginWithEmail({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "login" });
      try {
        const response = yield call(
          authService.login,
          payload.data,
          payload.shopId,
        );

        if (
          response.user.role === "shop-owner" ||
          response.user.role === "shop-admin" ||
          response.user.role === "shop-chef" ||
          response.user.role === "shop-pos-operator" ||
          response.user.role === "shop-waiter"
        ) {
          localStorage.setItem("accessToken", response.accessToken);
          localStorage.setItem("refreshToken", response.refreshToken);
          localStorage.setItem("userId", response.user.id);
          localStorage.setItem("shopId", response.user.shop_id);
          yield put({ type: "setUser", user: response.user });
        } else {
          message.error(
            "You don't have the required role to perform this action.",
          );
        }
        yield put({ type: "stopLoading", loadingType: "login" });
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "login" });
      }
    },

    *verifyEmail({ payload }, { call, put }) {
      try {
        const response = yield call(
          authService.verifyEmail,
          payload.data,
          payload.shopId,
        );
        yield put({ type: "setUser", user: response.data });
      } catch (error) {
        localErrorHandler({ namespace, error });
      }
    },
  },
  reducers: {
    setShops(state, { shops }) {
      return { ...state, shops };
    },
    setUser(state, { user }) {
      return { ...state, user };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};
